import React from 'react';
import { SortOption } from '../../../redux/slices/marketplaceSlice';
import './SortControls.scss';

interface SortControlsProps {
  activeSort: SortOption;
  onSortChange: (sort: SortOption) => void;
}

const SortControls: React.FC<SortControlsProps> = ({ activeSort, onSortChange }) => {
  return (
    <div className="sort-controls">
      <label htmlFor="sort-select" className="sort-label">
        Sort by:
      </label>
      <select
        id="sort-select"
        className="sort-select"
        value={activeSort}
        onChange={(e) => onSortChange(e.target.value as SortOption)}
      >
        <option value="highest-value">Highest Price</option>
        <option value="lowest-value">Lowest Price</option>
        <option value="trending">Trending</option>
        <option value="most-popular">Most Popular</option>
      </select>
    </div>
  );
};

export default SortControls;
